<template>
  <div class="app-order-shopping-card accordion-inner">
    <slot name="txtBefore"></slot>
    <slot name="txtBeforeTariff"></slot>
    <table v-if="presalesTariff">
      <thead>
      <tr>
        <th>Ihre Auswahl</th>
        <th>Einmalig</th>
        <th>4 Wochen</th>
      </tr>
      </thead>
      <tbody>
      <tr class="tariff">
        <td v-html="tariffsExtra.descriptionOrdering"></td>
        <td v-html="presalesTariff.starterKit[0].formattedSinglePaymentFee"></td>
        <td v-html="presalesTariff.formattedBasicFee"></td>
      </tr>
      <tr class="tariff-info">
        <td>
          <ul>
            <li class="extra-info" v-for="info in tariffsExtra.info" :key="info">{{info}}</li>
          </ul>
        </td>
        <td></td>
        <td></td>
      </tr>
      <tr class="shipping-info">
        <td>
          <div>
            <span class="sub-heading">Die Versandkosten übernehmen wir für dich!</span>
          </div>
        </td>
        <td>0 €</td>
        <td>---</td>
      </tr>
      <tr class="mnp-info">
        <td>
          <div>
            <span class="sub-heading">
              <slot name="mnpText"></slot>
            </span>
          </div>
        </td>
        <td></td>
        <td></td>
      </tr>
      </tbody>
      <tfoot>
      <tr class="sum sum-content">
        <td>
          <span>Gesamtsumme</span> <span>inkl. 19 % MwSt.</span>
        <td class="sumSingleCosts">einm. <strong>{{presalesTariff.starterKit[0].formattedSinglePaymentFee}}</strong></td>
        <td class="sumAnnualCosts">alle 4 Wochen <strong>{{presalesTariff.formattedBasicFee}}</strong></td>
      </tr>
      </tfoot>
    </table>
    <div v-if="presalesTariff" class="order-step">
      <b-overlay v-if="this.getStep === stepName" class="btn-next-overlay" :show="loading" spinner-small>
        <b-button @click="next" class="btn-next" type="button" variant="primary" :disabled="loading">
          <slot name="btnNext">weiter</slot>
        </b-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { mapGetters, mapMutations } from 'vuex'
import slotProxy from '@/mixins/slotProxy'

export const stepName = 'shoppingCard'
export default {
  name: 'ShoppingCard',
  components: {
    BButton
  },
  import: { stepName },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('orderProduct', [
      'getStep'
    ])
  },
  methods: {
    ...mapMutations('orderProduct', {
      changeStep: 'changeStep'
    }),
    ...mapMutations('orderProduct/product', [
      'commitSumCosts'
    ]),
    next () {
      this.loading = true
      this.changeStep({ step: this.nextStep })
      this.commitSumCosts(this.presalesTariff.starterKit[0].formattedCombinedCost)
      this.loading = false
    }
  },
  props: {
    nextStep: {
      type: String,
      default: 'options'
    },
    presalesTariff: {
      type: Object,
      default: () => {}
    },
    tariffsExtra: {
      type: Object,
      default: () => {}
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
